import { REPORT_TEMPLATE, type IReportCardInfo, type IdeaSummaryCardInfo } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import _ from 'lodash'
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';

export const IdeaSummaryService = Symbol('IdeaSummaryService');

export type IdeaSummaryService = BaseCardService<IdeaSummaryCardInfo>

@injectable()
export class IdeaSummaryServiceImpl extends BaseCardServiceImpl<IdeaSummaryCardInfo> implements IdeaSummaryService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.IDEA_SUMMARY;

    constructor(
    @inject(ReportApiService) _reportApiService: ReportApiService
    ) {
        super(
            _reportApiService
        );
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));
        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            const data = updatedValue.data?.[REPORT_TEMPLATE.IDEA_SUMMARY]
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data,
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
